import { useEffect, useMemo } from 'react';
import { useAudioPlayer } from './useAudioPlayer';
import type { AudioCallStatus } from './useAudioCallStatus';
import useAppointmentEvents from '@hooks/useAppointmentEvents';
import { Appointment } from 'vl-common/src/schemas/shared/appointment';

const SOUND_MAP: Record<AudioCallStatus, string | null> = {
  idle: null,
  initiated: null,
  ringing: null,
  answered: null,
  'in-progress': null,
  completed: null,
  failed: '/static/sit.mp3',
  'no-answer': '/static/busy.mp3',
  busy: '/static/busy.mp3',
  canceled: null
};

export const useRinger = (status: AudioCallStatus, appointment: Appointment) => {
  const soundSrc = useMemo(() => SOUND_MAP[status], [status]);
  const { play, stop } = useAudioPlayer(soundSrc ?? '');
  const { connected } = useAppointmentEvents(appointment);

  useEffect(() => {
    if (!connected) return;
    if (soundSrc) {
      play();
    } else {
      stop();
    }
    return () => {
      stop();
    };
  }, [soundSrc, play, stop, connected]);
};
